import { judo } from './judo';

class JudoPayment {
  cardDetails = null;

  get activeCardDetails() {
    return this.cardDetails;
  }

  initPayment = (...args) => {
    this.cardDetails = judo.createCardDetails(...args);
    return this.cardDetails;
  };

  createToken = (...args) => judo.createToken(...args);

  reset() {
    this.cardDetails = null;
  }
}

export default new JudoPayment();
